import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const SAAllCourses = () => {
    const [courses, setCourses] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchCourses();
    }, []);

    const fetchCourses = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/studyabroad/all');
            const data = await response.json();
            setCourses(data);
        } catch (error) {
            console.error('Error fetching courses:', error);
        }
    };

    const handleDelete = async (courseId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this course?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/studyabroad/delete/${courseId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        // Update local state after successful deletion
                        setCourses(courses.filter(course => course.id !== courseId));
                        
                        // Show success message
                        Swal.fire({
                            title: "Deleted!",
                            text: "The course has been deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete course');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to delete the course.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting course:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to delete the course.",
                        icon: "error"
                    });
                }
            }
        });
    };

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    // Filter courses based on search term
    const filteredCourses = courses.filter((course) =>
        course.country?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        course.university?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        course.courseName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        course.level?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        course.duration?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // const handleEdit = (courseId) => {
    //     // Navigate to edit page or show edit form in place
    //     // For example, navigate to `/edit-course/${courseId}` or show form inline
    //     console.log('Edit course with ID:', courseId);
    // };

    return (
        <div>
            <AdminDashboard />

            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>ALL COURSES</h1>
                    <form onSubmit={(e) => e.preventDefault()}>
                        <input 
                            type="text" 
                            placeholder='Search courses, universities, countries...' 
                            value={searchTerm}
                            onChange={handleSearch}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                    <table>
                            <thead>
                                <tr>
                                    <th>Country</th>
                                    <th>University / Institute</th>
                                    <th>Course / Degree Name</th>
                                    <th>Level</th>
                                    <th>Duration</th>
                                    <th>Start Date</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredCourses.length > 0 ? (
                                    filteredCourses.map((course) => (
                                        <tr key={course.id}>
                                            <td>{course.country}</td>
                                            <td>{course.university}</td>
                                            <td>{course.courseName}</td>
                                            <td>{course.level}</td>
                                            <td>{course.duration}</td>
                                            <td>{new Date(course.startDate).toLocaleDateString('en-CA')}</td>
                                            <td>
                                                {course.website ? (
                                                    <a href={course.website} target="_blank" rel="noopener noreferrer" id='view-website'>WEBSITE</a>
                                                ) : (
                                                    <span style={{ color: '#999' }}>No Website</span>
                                                )}
                                            </td>
                                            <td id='action-buttons'>
                                                <a href="#!" id='del-details' onClick={() => handleDelete(course.id)}>DELETE</a>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                                            {searchTerm ? 'No courses found matching your search.' : 'No courses available.'}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SAAllCourses;
